module.exports = __webpack_public_path__ + "static/media/timer-bg.827438df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/groupBuy/timer-bg.png
// module id = 2007
// module chunks = 4